import React, { Component } from "react";
import { addDays, differenceInCalendarDays, format } from "date-fns";
import DesktopCalender from "../../../calendar/hotelCalender/theme8/DesktopCalender";
import HotelAutoComplete from "./HotelAutoComplete";
import cf from "../../../../lib/utils/common";
import MobPopupComponent from "../../../ModalPopupComponent/theme8mobile/ModalPopupComponent";
import MobileCalender from "../../../calendar/hotelCalender/theme8/MobileCalender";
import commonFunction from "../../../../lib/utils/common";
import { getRecentSearchHotel } from "../../../../lib/getRecentSearchHotel";
import { getStorage, setStorage } from "../../../../lib/utils/localStorage";
import Button from "../../../UI/button/index.js";
import { alphanumericSpecialChars, leadingSpaces } from "../../../../lib/utils/regex_cheat_sheet";
import PaxComp from "../../../PaxComp";
import moment from 'moment'

let regions = "";
let indexDropdown = -1;
let search_text = "";
let destination_id = "";
let search_type = "";
export default class Theme2 extends Component {
  constructor(props) {
    super(props);
    this.setScrollDown = React.createRef();
    this.wrapperRef = React.createRef();
    this.advanceSearchWrapper = React.createRef();
    this.guestDetailWrapper = React.createRef();
    this.setScrollCal = React.createRef();
    this.state = {
      hotelName: "",
      expandHotelNameBoolean: false,
      checkInOutValue: "",
      checkInValue: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
      checkOutValue: cf.getDateWithFormat(
        addDays(
          new Date(),
          this.props.getDefaultDays ? this.props.getDefaultDays : 2
        ),
        this?.props?.dateFormat
      ),
      dateLimit: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
      openRoomDetailList: false,
      expandCheckInOutDateBoolean: false,
      selectedRoomDetails: { rooms: 1, guest: 2 },
      getAutoSuggestList: this.props.getAutoSuggestList,
      isError: {
        hotelName: false,
        checkInOutDate: false,
        roomGuest: false,
        selectedNationality: false,
        selectedGuest: false,
      },
      getDestinationId: "",
      getSearchType: "",
      property_count: "",
      dest_type: {
        code: "",
        name: "",
      },
      roomList: [
        {
          id: 1,
          adults: 2,
          children: 0,
          adultAddCountDisable: false,
          adultMinusCountDisable: false,
          childrenAddCountDisable: false,
          childrenMinusCountDisable: true,
          childDetails: [],
        },
      ],

      finalRoomList: [
        {
          id: 1,
          adults: 2,
          children: 0,
          adultAddCountDisable: false,
          adultMinusCountDisable: true,
          childrenAddCountDisable: false,
          childrenMinusCountDisable: true,
          childDetails: [],
        },
      ],
      type: "hotel",
      openTraveler: false,
      advSearch: false,
      nationallitySearch: "",
      is_breakfast: "",
      originCountries: [],
      selectedNationality: "",
      response: [],
      isOneStar: false,
      isTwoStar: false,
      isThreeStar: false,
      isFourStar: false,
      isFiveStar: false,
      selectedCheckBoxes: {},
      guest_id: "",
      openSearch: false,
      destination: false,
      calender: false,
      rooms: false,
      selectedDestination: null,
      getrecentSearchList: null,
      getrecentSearchListLocal: null,
      search_key: "hotelSearchKey",
      search_key_all: "hotelSearchKeyAll",
      isKeyDown: false,
      isSearchDest: false,
      btnClicked: false,
      recentSearchClicked: this.props?.state?.recentSearchClicked,
      roomsData: [],
      isRecentSearch: false,
    };
  }


  componentDidMount() {

    // recent serach sec ==>
    if (this.props.isSrp === false) {
      this.props.updateRecentSearch("element");
    }
    let LocalSearch = getStorage(this.state.search_key);

    let LocalSearchAll = getStorage(this.state.search_key_all);

    if (LocalSearchAll != null) {
      this.setState({ getrecentSearchListLocal: JSON.parse(LocalSearchAll) });
    }
    if (LocalSearch != null && LocalSearchAll == null) {
      this.setState({ getrecentSearchListLocal: [JSON.parse(LocalSearch)] });
    }


    if (this.props?.recentSearchData && this.props?.recentSearchData.length > 0) {
      this.props.recentSearchData.map((element, index) => {


        if (index == 0) {

          let formattedDate = moment(element?.checkin, "DD-MM-YYYY").format("DD-MMM-YYYY");

          this.setState({
            hotelName: element.search_text,
            getDestinationId: element.destination_id,
            getSearchType: element.search_type,
            property_count: element.property_count,
            dest_type: {
              code: element.dest_type?.code,
              text: element.dest_type?.text,
            },
            checkInOutValue: cf.getDateWithFormat(new Date(formattedDate), this?.props?.dateFormat) + " - " +
              cf.getDateWithFormat(addDays(new Date(formattedDate),
                this.props.getDefaultDays ? this.props.getDefaultDays : 2
              ), this?.props?.dateFormat),
            checkInValue: cf.getDateWithFormat(new Date(formattedDate), this?.props?.dateFormat),
            checkOutValue: cf.getDateWithFormat(
              addDays(
                new Date(formattedDate),
                this.props.getDefaultDays ? this.props.getDefaultDays : 2
              ),
              this?.props?.dateFormat
            ),
            selectedRoomDetails: element?.selectedRoomDetails,
            roomsData: element?.roomList,
            isRecentSearch: true,
          });
        }
      });
    }


    regions = new URLSearchParams(window.location.search).get("region");
    if (
      !cf.isValueEmpty(this.props) &&
      (this.props.isSRP === true || this.props.isDetail === true) &&
      !cf.isValueEmpty(this.props.query)
    ) {
      let checkInArr = this.props.query.checkin.split("-");
      let checkOutArr = this.props.query.checkout.split("-");
      let checkInValue = cf.getDateWithFormat(
        new Date(checkInArr[0], Number(checkInArr[1]) - 1, checkInArr[2]),
        this?.props?.dateFormat
      );
      let checkOutValue = cf.getDateWithFormat(
        new Date(checkOutArr[0], Number(checkOutArr[1]) - 1, checkOutArr[2]),
        this?.props?.dateFormat
      );
      let checkInOut =
        cf.getDateWithFormat(
          new Date(checkInArr[0], Number(checkInArr[1]) - 1, checkInArr[2]),
          this?.props?.dateFormat
        ) +
        " - " +
        cf.getDateWithFormat(
          new Date(checkOutArr[0], Number(checkOutArr[1]) - 1, checkOutArr[2]),
          this?.props?.dateFormat
        );
      let roomsdetail = this.props.query.rooms.split("_");
      let totalRooms = roomsdetail.length;
      let totalAdult = 0;
      let totalChildren = 0;
      let roomListArr = [];
      let finalRoomListArr = []; //new
      roomsdetail.map((ele, index) => {
        let split = ele.split("-").filter((item) => item);
        totalAdult = Number(split[0].charAt(0)) + totalAdult;
        totalChildren = Number(split[1].charAt(0)) + totalChildren;
        roomListArr = [
          ...roomListArr,
          {
            id: index + 1,
            adults: Number(split[0].charAt(0)),
            children: Number(split[1].charAt(0)),
            adultAddCountDisable: false,
            adultMinusCountDisable: true,
            childrenAddCountDisable: false,
            childrenMinusCountDisable:
              Number(split[1].charAt(0)) == 1 ? false : true,
            childDetails: [],
          },
        ];

        split.map((element, id) => {
          if (id > 1)
            roomListArr[index].childDetails = [
              ...roomListArr[index].childDetails,
              { age: element, isOpen: false, isError: false },
            ];
        });
      });
      this.setState(
        {
          checkInOutValue: checkInOut,
          checkInValue: checkInValue,
          checkOutValue: checkOutValue,
          getDestinationId: this.props.query.destid,
          getSearchType: this.props.query.search_type,
          hotelName: this.props.AutoSuggestLabelName
            ? this.props.AutoSuggestLabelName
            : this?.props?.query?.region + ", " + this?.props?.query?.country,
          selectedRoomDetails: {
            rooms: totalRooms,
            guest: totalAdult + totalChildren,
          },
          roomList: roomListArr,
          nationallitySearch: this.props.query.nationality,
          // response:this.props.query.ratings,
          guest_id: this.props.query.guestId,
        },
        // this.setState(prevState => ({
        //   ...prevState.selectedCheckBoxes,
        //   selectedCheckBoxes: {
        //       breakfast:[[this.props.query.bf]],
        //       room_type:[[this.props.query.rf]],
        //   }
        // })),
        () => {
          this.checkRoomDetails();
        }
      );
      const deepClone = JSON.parse(JSON.stringify(roomListArr));
      this.setState({
        finalRoomList: deepClone,
      });
    } else {
      if (regions) {
        this.renderInfo();
        // Detail Page Conditions
        if (this.props.isDetail) {
          let checkInArr = this.props.query.checkin.split("-");
          let checkOutArr = this.props.query.checkout.split("-");
          let checkInValue = cf.getDateWithFormat(
            new Date(checkInArr[0], Number(checkInArr[1]) - 1, checkInArr[2]),
            this?.props?.dateFormat
          );
          let checkOutValue = cf.getDateWithFormat(
            new Date(
              checkOutArr[0],
              Number(checkOutArr[1]) - 1,
              checkOutArr[2]
            ),
            this?.props?.dateFormat
          );

          let checkInOut =
            cf.getDateWithFormat(
              new Date(checkInArr[0], Number(checkInArr[1]) - 1, checkInArr[2]),
              this?.props?.dateFormat
            ) +
            " - " +
            cf.getDateWithFormat(
              new Date(
                checkOutArr[0],
                Number(checkOutArr[1]) - 1,
                checkOutArr[2]
              ),
              this?.props?.dateFormat
            );

          let roomsdetail = this.props.query.rooms.split("_");
          let totalRooms = roomsdetail.length;
          let totalAdult = 0;
          let totalChildren = 0;
          let roomListArr = [];
          let finalRoomListArr = []; //new
          roomsdetail.map((ele, index) => {
            let split = ele.split("-").filter((item) => item);
            totalAdult = Number(split[0].charAt(0)) + totalAdult;
            totalChildren = Number(split[1].charAt(0)) + totalChildren;
            roomListArr = [
              ...roomListArr,
              {
                id: index + 1,
                adults: Number(split[0].charAt(0)),
                children: Number(split[1].charAt(0)),
                adultAddCountDisable: false,
                adultMinusCountDisable: true,
                childrenAddCountDisable: false,
                childrenMinusCountDisable:
                  Number(split[1].charAt(0)) == 1 ? false : true,
                childDetails: [],
              },
            ];

            split.map((element, id) => {
              if (id > 1)
                roomListArr[index].childDetails = [
                  ...roomListArr[index].childDetails,
                  { age: element, isOpen: false, isError: false },
                ];
            });
          });

          this.setState({
            checkInOutValue: checkInOut,
            checkInValue: checkInValue,
            checkOutValue: checkOutValue,
            hotelName:
              this?.props?.query?.region + ", " + this?.props?.query?.country,
            getDestinationId: this?.props?.query?.destid,
            getSearchType: this?.props?.query?.search_type,
            selectedRoomDetails: {
              rooms: totalRooms,
              guest: totalAdult + totalChildren,
            },
            roomList: roomListArr,
            vid: this.props?.query?.vid,
            sid: this.state.getSearchType == 21 ? "" : this?.props?.query?.sid,
          });
        }
      }

      if (!this.props.isDetail && (this.props?.recentSearchData && this.props?.recentSearchData.length == 0)) {
        this.setState({
          checkInOutValue: this.getCheckInOutValue(
            this.state.checkInValue,
            this.state.checkOutValue
          ),
        });
      }
    }
    document.addEventListener("mousedown", this.handleClickOutside);

  }


  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  checkRoomDetails() {
    let { roomList } = this.state;
    roomList.map((ele, index) => {
      let totalAccomodation = ele.adults + ele.children;
      if (totalAccomodation <= 12) {
        if (totalAccomodation === 12) {
          roomList[index].adultAddCountDisable = true;
          roomList[index].childrenAddCountDisable = true;
        } else if (totalAccomodation < 12) {
          if (
            roomList[index].adultAddCountDisable === true &&
            roomList[index].childrenAddCountDisable === true
          ) {
            roomList[index].adultAddCountDisable = false;
            roomList[index].childrenAddCountDisable = false;
          }
          if (roomList[index].adults > 1) {
            roomList[index].adultMinusCountDisable = false;
          } else if (roomList[index].adults === 1) {
            roomList[index].adultMinusCountDisable = true;
            roomList[index].adultAddCountDisable = false;
          }
          if (roomList[index].children > 1) {
            roomList[index].childrenMinusCountDisable = false;
          } else if (roomList[index].children > 0) {
            roomList[index].childrenMinusCountDisable = false;
            roomList[index].childrenAddCountDisable = false;
          }
        }
      }
    });
    this.setState({ roomList: [...roomList] });
  }
  handleClickOutside = (e) => {
    if (
      this.dropdownWrapperRef &&
      !this.dropdownWrapperRef.contains(e.target)
    ) {
      if (this.props.expandHotelNameBoolean === true)
        this.props.expandHotelNameBooleanfunc(false);
      if (
        this.advanceSearchWrapper.current &&
        !this.advanceSearchWrapper.current.contains(event.target)
      ) {
        this.setState({ advSearch: false });
      }
      if (
        this.guestDetailWrapper.current &&
        !this.guestDetailWrapper.current.contains(event.target)
      ) {
        this.setState({ openTraveler: false });
      }
      if (
        this.state.expandCheckInOutDateBoolean === true ||
        this.state.openRoomDetailList === true
      ) {
        this.setState({
          expandCheckInOutDateBoolean: false,
          openRoomDetailList: false,
        });
      }
    }
  };

  setDropdownWrapperRef = (node) => {
    this.dropdownWrapperRef = node;
  };

  onClickDoneButton = () => {
    let totalGuest = 0;
    let count = 0;
    let Validation = true;
    let validation_arr = [];
    let roomList = this.state.roomList;

    while (count <= roomList.length) {
      if (
        !cf.isValueEmpty(roomList[count]) &&
        !cf.isValueEmpty(roomList[count].childDetails) &&
        roomList[count].childDetails.length > 0
      ) {

        roomList[count].childDetails.map((element, index) => {
          if (cf.isValueEmpty(element.age)) {
            roomList[count].childDetails[index].isError = true;
          }
        });

        validation_arr.push(
          roomList[count].childDetails.every(
            (item) => !cf.isValueEmpty(item.age)
          )
        );
        let checker = validation_arr.every(Boolean);
        Validation = checker;
      }
      count++;
    }

    this.setState({ roomList: [...roomList] }, () => {
      if (Validation === true) {
        this.state.roomList.length > 0 &&
          this.state.roomList.map((element) => {
            totalGuest = totalGuest + element.adults + element.children;
          });

        this.setState({
          selectedRoomDetails: {
            rooms: this.state.roomList.length,
            guest: totalGuest,
          },
        });
        const deepClone = JSON.parse(JSON.stringify(roomList));
        this.setState({
          finalRoomList: deepClone,
        });
        this.setState({ rooms: false }, () => {
          const mapDispatch = {
            hotelName: cf.isValueEmpty(this.state.hotelName),
            checkInOutDate: cf.isValueEmpty(this.state.checkInOutValue),
            roomGuest: cf.isValueEmpty(this.state.selectedRoomDetails)
          };
          if (!mapDispatch.hotelName && !mapDispatch.checkInOutDate && !mapDispatch.roomGuest) {
            this.onClickSearchHotel();
          }
        });
        document.querySelector("body").style.overflow = "auto";
        if (this.state.openRoomDetailList === true) {
          this.setState({ openRoomDetailList: false });
        }
      }
    });
  };

  removeRoomItem = (id) => {
    const filteredRoom = this.state.roomList.filter((item) => item.id !== id);
    this.setState({ roomList: [...filteredRoom] });
  };

  addAccomodationCount = async (id, index, type) => {
    let { roomList } = this.state;
    if (type === "adult") {
      if (roomList[index].id === id) {
        roomList[index].adults = roomList[index].adults + 1;
      }
    } else {
      if (roomList[index].id === id) {
        roomList[index].children = roomList[index].children + 1;
        roomList[index].childDetails = [
          ...roomList[index].childDetails,
          { age: "", isOpen: false, isError: false },
        ];
      }
    }
    let totalAccomodation = roomList[index].adults + roomList[index].children;

    if (this.props?.stays_villas) {
      if (totalAccomodation <= 20) {

        if (roomList[index].adults == 14) {
          roomList[index].adultAddCountDisable = true;
        }
        if (roomList[index].children == 6) {
          roomList[index].childrenAddCountDisable = true;
        }

        if (roomList[index].adults > 1) {
          roomList[index].adultMinusCountDisable = false;
        }
        if (roomList[index].children > 0) {
          roomList[index].childrenMinusCountDisable = false;
        }
        await this.setState({ roomList: [...roomList] });
      }
    } else {
      if (totalAccomodation <= 7) {
        if (totalAccomodation === 7) {
          roomList[index].adultAddCountDisable = true;
          roomList[index].childrenAddCountDisable = true;
        } else if (totalAccomodation < 7) {
          if (
            roomList[index].adultAddCountDisable === true &&
            roomList[index].childrenAddCountDisable === true
          ) {
            roomList[index].adultAddCountDisable = false;
            roomList[index].childrenAddCountDisable = false;
          }
        }
        if (roomList[index].adults > 1) {
          roomList[index].adultMinusCountDisable = false;
        }
        if (roomList[index].children > 0) {
          roomList[index].childrenMinusCountDisable = false;
        }
        await this.setState({ roomList: [...roomList] });
      }
    }

  };

  minusAccomodationCount = async (id, index, type) => {
    let { roomList } = this.state;
    if (type === "adult") {
      if (roomList[index].id === id) {
        if (roomList[index].adults >= 2) {
          roomList[index].adults = roomList[index].adults - 1;
          roomList[index].adultMinusCountDisable = roomList[index].adults === 1 ? true : false;
          if (roomList[index].adultAddCountDisable === true) {
            roomList[index].adultAddCountDisable = false;
          }
          if (!this.props?.stays_villas) {
            if (roomList[index].childrenAddCountDisable === true) {
              roomList[index].childrenAddCountDisable = false;
            }
          }

        } else if (roomList[index].adults === 1) {
          roomList[index].adultMinusCountDisable = true;
        }
      }
    } else {
      if (roomList[index].id === id) {
        roomList[index].childDetails.pop();
        if (roomList[index].children >= 1) {
          roomList[index].children = roomList[index].children - 1;
          roomList[index].childrenMinusCountDisable = false;
          if (roomList[index].childrenAddCountDisable === true) {
            roomList[index].childrenAddCountDisable = false;
          }
          if (roomList[index].adultAddCountDisable === true) {
            roomList[index].adultAddCountDisable = false;
          }
        } else if (roomList[index].children === 0) {
          roomList[index].childrenMinusCountDisable = true;
        }
      }
    }
    await this.setState({ roomList: [...roomList] });
  };

  isChildrenAge = (index, ind, type, age) => {
    let { roomList } = this.state;
    if (type === "isOpen") {
      roomList[index].childDetails[ind].isOpen =
        !roomList[index].childDetails[ind].isOpen;
    } else {
      roomList[index].childDetails[ind].age = age;
      roomList[index].childDetails[ind].isOpen = false;
      if (roomList[index].childDetails[ind].isError === true) {
        roomList[index].childDetails[ind].isError = false;
      }
    }
    this.setState({ roomList: [...roomList] });
  };

  onChangeCheckInOutValue = (value, type) => {

    if (type === "startDate") {
      this.setState({ checkInValue: value });

    } else if (type === "endDate") {
      let differenceInDays = differenceInCalendarDays(
        new Date(value),
        new Date(this.state.checkInValue)
      );

      if (differenceInDays === 0) {
        this.setState({ checkOutValue: addDays(new Date(value), 1) }, () => {
          if (!cf.isValueEmpty(value)) {
            let checkInOut =
              cf.getDateWithFormat(
                this?.state?.checkInValue,
                this?.props?.dateFormat
              ) +
              " - " +
              cf.getDateWithFormat(
                this?.state?.checkOutValue,
                this?.props?.dateFormat
              );
            this.setState({
              checkInOutValue: checkInOut,
              openRoomDetailList: this.props.isMobile ? false : true
            });
          }
        });
      } else {
        this.setState({ checkOutValue: value }, () => {
          if (!cf.isValueEmpty(value)) {
            let checkInOut =
              cf.getDateWithFormat(
                this?.state?.checkInValue,
                this?.props?.dateFormat
              ) +
              " - " +
              cf.getDateWithFormat(value, this?.props?.dateFormat);
            this.setState({
              checkInOutValue: checkInOut,
              // openRoomDetailList: this.props.isMobile ? false : true
            });

          }
        });
      }
    }

  };

  onChangeSetHotelName = (value) => {
    let regexNum = alphanumericSpecialChars.test(value);

    if (regexNum) {
      this.setState(
        {
          hotelName: value.replace(leadingSpaces, ""), getDestinationId: "", isError: {
            ...this.state.isError,
            hotelName: false
          }
        },
        () => {
          if (this.state.isError.hotelName === true) {
            this.validateErrorMsg();
          }
          if (value.length > 2) {
            this.setState({ isSearchDest: true });
            this.props.getAutoSuggestValue(value);
          }
        }
      );
    }
  };

  validateErrorMsg = () => {
    const mapDispatch = {
      hotelName: cf.isValueEmpty(this.state.hotelName) ? true : false,
      checkInOutDate: cf.isValueEmpty(this.state.checkInOutValue)
        ? true
        : false,
      roomGuest: cf.isValueEmpty(this.state.selectedRoomDetails) ? true : false,

      selectedGuest: cf.isValueEmpty(this.state.guest_id) ? true : false,
    };
    this.setState({ isError: mapDispatch });
  };

  onClickSearchHotel = () => {

    if (
      this.state.hotelName &&
      this.props.getAutoSuggestList &&
      this.props.getAutoSuggestList?.length > 0
    ) {
      let LocalSearch = getStorage(this.state.search_key);
      let LocalSearchAll = JSON.parse(getStorage(this.state.search_key_all));
      const searchItem = JSON.parse(LocalSearch);
      let roomListArr = [];
      this.state.finalRoomList.map((res, id) => {
        roomListArr = [
          ...roomListArr,
          res.adults + "a-" + res.children + "c",
        ];
        res.childDetails.map((ele) => {
          roomListArr[id] = roomListArr[id].concat("-", ele.age);
        });
      });

      if (LocalSearch) {
        if (LocalSearchAll == null) {
          var searchData = getStorage(this.state.search_key);
          var searchDataArr = [JSON.parse(searchData)];

          let myObject = {
            destination_id: this.state.getDestinationId,
            search_type: this.state.getSearchType,
            search_text: this.state.hotelName,
            property_count: this.state.property_count,
            dest_type: {
              code: this.state.dest_type?.code || "",
              text: this.state.dest_type?.text || "",
            },
            checkin: format(new Date(this.state.checkInValue), "dd-MM-yyyy"),
            checkout: format(new Date(this.state.checkOutValue), "dd-MM-yyyy"),
            selectedRoomDetails: this.state.selectedRoomDetails,
            roomList: roomListArr.join("_"),
            is_breakfast: this.props?.state?.showBreakfast ? this.props?.state?.showBreakfast : null,
            is_free_cancellation: this.props.state?.showFreeCancellation ? this.props.state.showFreeCancellation : null,
          };

          if (searchItem.destination_id !== myObject.destination_id) {
            searchDataArr.unshift(myObject);
            var searchDataStrig = JSON.stringify(searchDataArr);
            setStorage(this.state.search_key, searchDataStrig);
            setStorage(
              this.state.search_key_all,
              JSON.stringify(searchDataArr)
            );
          }
        }

        if (LocalSearchAll) {
          var searchData = getStorage(this.state.search_key);
          var searchDataAll = JSON.parse(getStorage(this.state.search_key_all));
          var searchDataArr = [JSON.parse(searchData)];
          var indexArr = [];
          searchDataAll.forEach((x, i) => {
            indexArr.push(x.destination_id);
          });

          let myObject = {
            destination_id: this.state.getDestinationId,
            search_type: this.state.getSearchType,
            search_text: this.state.hotelName,
            property_count: this.state.property_count,
            dest_type: {
              code: this.state.dest_type?.code || "",
              text: this.state.dest_type?.text || "",
            },
            checkin: format(new Date(this.state.checkInValue), "dd-MM-yyyy"),
            checkout: format(new Date(this.state.checkOutValue), "dd-MM-yyyy"),
            selectedRoomDetails: this.state.selectedRoomDetails,
            roomList: roomListArr.join("_"),
            is_breakfast: this.props?.state?.showBreakfast ? this.props?.state?.showBreakfast : null,
            is_free_cancellation: this.props.state?.showFreeCancellation ? this.props.state.showFreeCancellation : null,
          };


          if (!indexArr.includes(myObject.destination_id)) {
            searchDataAll.unshift(myObject);
            var searchDataStrig = JSON.stringify(searchDataArr);
            setStorage(
              this.state.search_key_all,
              JSON.stringify(searchDataAll)
            );
          }

          if (searchDataAll.length > 4) {
            searchDataAll.pop();
            setStorage(
              this.state.search_key_all,
              JSON.stringify(searchDataAll)
            );
          }
        }
      } else {
        var searchData = [];
        let data = {
          destination_id: this.state.getDestinationId,
          search_type: this.state.getSearchType,
          search_text: this.state.hotelName,
          property_count: this.state.property_count,
          dest_type: {
            code: this.state.dest_type?.code || "",
            text: this.state.dest_type?.text || "",
          },
          checkin: format(new Date(this.state.checkInValue), "dd-MM-yyyy"),
          checkout: format(new Date(this.state.checkOutValue), "dd-MM-yyyy"),
          selectedRoomDetails: this.state.selectedRoomDetails,
          roomList: roomListArr.join("_"),
          is_breakfast: this.props?.state?.showBreakfast ? this.props?.state?.showBreakfast : null,
          is_free_cancellation: this.props.state?.showFreeCancellation ? this.props.state.showFreeCancellation : null,
        };
        // searchData.push(data); // add the object to the array
        searchData.unshift(data);
        var searchDartaStrig = JSON.stringify(searchData);
        setStorage(this.state.search_key, searchDartaStrig);
      }

      let data = {
        destination_id: this.state.getDestinationId,
        search_type: this.state.getSearchType,
        search_text: this.state.hotelName,
        property_count: this.state.property_count,
        dest_type: {
          code: this.state.dest_type?.code || "",
          text: this.state.dest_type?.text || "",
        },
        checkin: format(new Date(this.state.checkInValue), "dd-MM-yyyy"),
        checkout: format(new Date(this.state.checkOutValue), "dd-MM-yyyy"),
        selectedRoomDetails: this.state.selectedRoomDetails,
        roomList: roomListArr.join("_"),
        is_breakfast: this.props?.state?.showBreakfast ? this.props?.state?.showBreakfast : null,
        is_free_cancellation: this.props.state?.showFreeCancellation ? this.props.state.showFreeCancellation : null,
      };
      setStorage(this.state.search_key, JSON.stringify(data));
    }

    // main function =====>

    const mapDispatch = {
      hotelName: cf.isValueEmpty(this.state.hotelName) ? true : false,
      checkInOutDate: cf.isValueEmpty(this.state.checkInOutValue)
        ? true
        : false,
      roomGuest: cf.isValueEmpty(this.state.selectedRoomDetails) ? true : false,

      selectedGuest: cf.isValueEmpty(this.state.guest_id) ? true : false,
    };

    if (this.props.isOffline !== true) {
      mapDispatch.selectedGuest = cf.isValueEmpty(this.state.selectedGuest)
        ? false
        : true;
    }
    if (!this.props.isOffline) {
      mapDispatch.selectedGuest = cf.isValueEmpty(this.state.selectedGuest)
        ? false
        : true;
    }

    if (this.props.isDetail == true) {
      mapDispatch.hotelName = cf.isValueEmpty(regions) ? true : false;
    }
    mapDispatch.hotelName = this.state.getDestinationId ? false : true;
    this.setState({ isError: mapDispatch }, () => {
      let Validate = true;
      for (const [key, value] of Object.entries(this.state.isError)) {
        if (value === true) {
          Validate = false;
          break;
        }
      }
      if (Validate === true) {
        let hotelNameArry = this.state.hotelName.split(",");
        let roomListArr = [];
        this.state.finalRoomList.map((res, id) => {
          roomListArr = [
            ...roomListArr,
            res.adults + "a-" + res.children + "c",
          ];
          res.childDetails.map((ele) => {
            roomListArr[id] = roomListArr[id].concat("-", ele.age);
          });
        });
        //IF CHECKOUT DATE IS EMPTY
        if (!this.state.checkOutValue) {
          this.state.checkOutValue = cf.getDateWithFormat(
            addDays(new Date(this.state.checkInValue), 2),
            this?.props?.dateFormat
          );
        }

        let urlQuery = {
          region: hotelNameArry[0]?.trim(),
          country:
            this.props.isSRP === true
              ? hotelNameArry[1]?.trim()
              : hotelNameArry[hotelNameArry.length - 1]?.trim(),
          checkin: format(new Date(this.state.checkInValue), "yyyy-MM-dd"),
          checkout: format(new Date(this.state.checkOutValue), "yyyy-MM-dd"),
          rooms: this.state.isRecentSearch ? this.state.roomsData : roomListArr.join("_"),
          type: "location",
          roomtype: "single",
          page: 1,
          orderby: "desc",
          mop: "accrual",
          destid: this.state.getDestinationId,
          search_type: this.state.getSearchType,
          ratings: "",
          is_breakfast: this.props?.state?.showBreakfast
            ? this.props?.state?.showBreakfast
            : null,
          is_free_cancellation: this.props.state?.showFreeCancellation
            ? this.props?.state.showFreeCancellation
            : null,
          is_stays_villas: this.props?.stays_villas
            ? this.props.stays_villas
            : null,
          nationality: this.state.nationallitySearch,
          guestId: this.state.guest_id,
          is_web_app: false,
          vid:
            this.state.getSearchType == 21
              ? this.state.getDestinationId
              : this?.props?.query?.vid,
          sid: this.state.getSearchType == 21 ? "" : this?.props?.query?.sid,
        };
        this.setState({
          btnClicked: true,
        });

        if (this.props.isDetail === true || this.state.getSearchType == 21) {
          const searchParams = new URLSearchParams(urlQuery);
          const queryString = searchParams.toString();
          localStorage.setItem("hotel_srp", "");
          window.location = "/hotel/details?" + queryString;
        } else {

          if (
            this.state.hotelName &&
            this?.props?.userProfile &&
            this?.props?.userProfile?.status
          ) {
            if (true) {
              let data = {
                destination_id: this.state.getDestinationId || "",
                search_type: this.state.getSearchType || "",
                search_text: this.state.hotelName || "",
                property_count: this.state.property_count || "",
                dest_type: {
                  code: this.state.dest_type?.code || "",
                  text: this.state.dest_type?.text || "",
                },
              };

              getRecentSearchHotel(data).then((res) => {
                // console.log("rrespppppp", res, this.props.getrecentSearchList);
              });
            }
          }
          if (this.props.isSRP) {
            this.props.setOpenMobWid();
          }
          localStorage.setItem("hotel_srp", JSON.stringify(urlQuery));
          cf.redirectTo("/hotel/search", urlQuery);
        }
      }
    });
  };

  onClickSetHotelName = (element) => {

    this.setState({
      hotelName: element.search_text,
      getDestinationId: element.destination_id,
      getSearchType: element.search_type ? element.search_type : 6,
      property_count: element?.property_count,
      dest_type: {
        code: element?.dest_type?.code,
        text: element?.dest_type?.text,
      },
      expandCheckInOutDateBoolean: this.props.isMobile ? false : true,
      isError: {
        ...this.state.isError,
        hotelName: false
      }
    }, () => {
      if (this.props.isMobile) {
        setTimeout(() => {
          this.setState({ expandCheckInOutDateBoolean: true })
        }, 500);
      }
    });
  };

  getCheckInOutValue = (checkIn, checkOut) => {
    let checkInArr = checkIn.split("/");
    let checkOutArr = checkOut.split("/");
    return checkIn + " - " + checkOut;
  };

  onClickVisibilityStatus = (type, value) => {
    if (!this.props?.isMobile && type != "hotel" && type != "calendar") {
      this.setScrollDown.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }

    switch (type) {
      case "hotel":
        this.props.expandHotelNameBooleanfunc(value);
        if (
          this.state.expandCheckInOutDateBoolean === true ||
          this.state.openRoomDetailList === true
        ) {
          this.setState({
            expandCheckInOutDateBoolean: false,
            openRoomDetailList: false,
          });
        }
        break;
      case "calendar":
        this.setState({ expandCheckInOutDateBoolean: value }, () => {
          if (
            this.props.expandHotelNameBoolean === true ||
            this.state.openRoomDetailList === true
          ) {
            this.setState({ openRoomDetailList: false });
            this.props.expandHotelNameBooleanfunc(false);
          }
          if (!this.state.expandCheckInOutDateBoolean && this.props.isMobile) {
            setTimeout(() => {
              this.setState({ rooms: true });
            }, 500);
          }
        });
        break;
      case "rooms":
        this.setState({ isRecentSearch: false });
        if (this.state.openRoomDetailList === false) {
          this.setState({ openRoomDetailList: true }, () => {
            if (
              this.props.expandHotelNameBoolean === true ||
              this.state.expandCheckInOutDateBoolean === true
            ) {
              this.setState({ expandCheckInOutDateBoolean: false });
              this.props.expandHotelNameBooleanfunc(false);
            }
          });
        } else {
          this.onClickDoneButton();
        }

        break;
      default:
        break;
    }
  };

  onClickHotelInput = () => {

    this.setState({ recentSearchClicked: false });
    this.props.onClickRecentSearch(false);
    this.props.getAutoSuggestValue("");
  };

  renderInfo = () => {
    this?.props?.getAutoSuggestValue(regions);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {

    if (prevProps?.state?.recentSearchClicked !== this.props?.state?.recentSearchClicked) {
      this.setState({ recentSearchClicked: true });
    }
    if (
      regions != null &&
      regions != "" &&
      regions != undefined &&
      !this.props.isSRP
    ) {
      if (
        prevProps?.getAutoSuggestList?.length <
        this?.props?.getAutoSuggestList?.length
      ) {
        prevProps.getAutoSuggestList = this.props.getAutoSuggestList;
        this.setState(
          {
            hotelName: prevProps.getAutoSuggestList[0].search_text,
            getDestinationId: prevProps.getAutoSuggestList[0].destination_id,
            getSearchType: prevProps.getAutoSuggestList[0].search_type,
          },
          () => {
            this.props.expandHotelNameBooleanfunc(false);
          }
        );
      }
    }

    // recent searh sec ==>

    if (this.state.recentSearchClicked && this.props.state?.hotelName
      && this.props.state?.hotelName !== this.state.hotelName
    ) {
      this.setState({
        hotelName: this.props.state.hotelName,
        getDestinationId: this.props.state.getDestinationId,
        getSearchType: this.props.state.getSearchType,
        property_count: this.props.state.property_count,
        dest_type: {
          code: this.props.state.dest_type?.code,
          text: this.props.state.dest_type?.text,
        },
        checkInOutValue: cf.getDateWithFormat(new Date(this.props.state?.checkin), this?.props?.dateFormat) + " - " +
          cf.getDateWithFormat(new Date(this.props.state?.checkout), this?.props?.dateFormat),
        checkInValue: cf.getDateWithFormat(new Date(this.props.state?.checkin), this?.props?.dateFormat),
        checkOutValue: cf.getDateWithFormat(new Date(this.props.state?.checkout), this?.props?.dateFormat),
        selectedRoomDetails: this.props.state?.selectedRoomDetails,
        roomsData: this.props.state?.roomList,
        isRecentSearch: true,
      });
    }


  }

  onInputFocus = (fieldName) => {
    if (fieldName == "autocomplete") {
      this.onClickVisibilityStatus("hotel", true);
    }
    if (fieldName == "calendar") {
      this.onClickVisibilityStatus("calendar", true);
      this.setState({ expandCheckInOutDateBoolean: true });
    }
    if (fieldName == "rooms") {
      this.onClickVisibilityStatus("rooms");
      this.setState({
        openRoomDetailList: true,
      });
    }
    if (fieldName == "search") {
      this.setState({ openRoomDetailList: false });
    }
  };

  highlightData(id, parentElement) {
    let innerContent = document.getElementById(parentElement).children;
    for (let i = 0; i < innerContent.length; i++) {
      let selectedElement = innerContent[i];
      selectedElement.style.backgroundColor = i == id ? "#ccc" : "#fff";
    }
    innerContent[id].scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });
  }

  onKeyDownArrow = (event, parentClassId, moduleType) => {
    const autoSuggestList = !cf.isValueEmpty(this.props.getAutoSuggestList)
      ? this.props.getAutoSuggestList
      : [];
    const recentSearchLogedin = this.props.getRecentSearchList;
    let recentSearchList = null;
    let mainArray = [];

    if (true) {
      let LocalSearch = getStorage(this.state.search_key);
      let LocalSearchAll = getStorage(this.state.search_key_all);

      if (LocalSearchAll != null) {
        recentSearchList = JSON.parse(LocalSearchAll);
      }
      if (LocalSearch != null && LocalSearchAll == null) {
        recentSearchList = [JSON.parse(LocalSearch)];
      }
    }

    if (this.props?.userProfile && this.props?.userProfile?.status) {
      if (recentSearchLogedin.length > 0 && autoSuggestList.length > 0) {
        mainArray = autoSuggestList.concat(recentSearchLogedin);
      } else if (
        recentSearchLogedin.length == 0 &&
        autoSuggestList.length > 0
      ) {
        mainArray = autoSuggestList;
      } else if (
        recentSearchLogedin.length > 0 &&
        autoSuggestList.length == 0
      ) {
        mainArray = recentSearchLogedin;
      } else {
        mainArray = [];
      }
    } else {
      if (recentSearchList?.length > 0 && autoSuggestList?.length > 0) {
        mainArray = autoSuggestList.concat(recentSearchList);
      } else if (recentSearchList == null && autoSuggestList?.length > 0) {
        mainArray = autoSuggestList;
      } else if (recentSearchList?.length > 0 && autoSuggestList?.length == 0) {
        mainArray = recentSearchList;
      } else {
        mainArray = [];
      }
    }

    if (mainArray.length > 0) {
      const ids = mainArray.map(({ destination_id }) => destination_id);
      mainArray = mainArray.filter(
        ({ destination_id }, index) => !ids.includes(destination_id, index + 1)
      );
    }

    this.setState({ isKeyDown: true });

    switch (event.which) {
      case 38: // up
        this.setState({ isKeyDown: true });
        if (mainArray.length > 0) {
          indexDropdown--;
          if (indexDropdown < 0) {
            indexDropdown = 0;
          }
          this.highlightData(indexDropdown, parentClassId);
          search_text =
            mainArray.length >= indexDropdown
              ? `${mainArray[indexDropdown].search_text}`
              : "";
          destination_id =
            mainArray.length >= indexDropdown
              ? `${mainArray[indexDropdown].destination_id}`
              : "";
          search_type =
            mainArray.length >= indexDropdown
              ? `${mainArray[indexDropdown].search_type
                ? mainArray[indexDropdown].search_type
                : 1
              }`
              : "";
        }

        break;
      case 40: // down
        this.setState({ isKeyDown: true });
        if (
          mainArray.length > 0 &&
          this.state.isKeyDown &&
          !this.state.isSearchDest
        ) {
          indexDropdown++;
          if (indexDropdown >= mainArray.length - 1) {
            indexDropdown = mainArray.length - 1;
          }
          this.highlightData(indexDropdown, parentClassId);
          search_text =
            mainArray.length >= indexDropdown
              ? `${mainArray[indexDropdown].search_text}`
              : "";
          destination_id =
            mainArray.length >= indexDropdown
              ? `${mainArray[indexDropdown].destination_id}`
              : "";
          search_type =
            mainArray.length >= indexDropdown
              ? `${mainArray[indexDropdown].search_type
                ? mainArray[indexDropdown].search_type
                : 1
              }`
              : "";
        }
        if (this.state.isSearchDest) {
          indexDropdown++;
          if (indexDropdown > this.props.getAutoSuggestList.length - 1) {
            indexDropdown = 0;
          }
          this.highlightData(indexDropdown, parentClassId);
          search_text =
            this.props.getAutoSuggestList.length >= indexDropdown
              ? `${this.props.getAutoSuggestList[indexDropdown].search_text}`
              : "";
          destination_id =
            this.props.getAutoSuggestList.length >= indexDropdown
              ? `${this.props.getAutoSuggestList[indexDropdown].destination_id}`
              : "";
          search_type =
            this.props.getAutoSuggestList.length >= indexDropdown
              ? `${this.props.getAutoSuggestList[indexDropdown].search_type
                ? this.props.getAutoSuggestList[indexDropdown].search_type
                : 1
              }`
              : "";
        }

        break;

      case 13: //enter
        this.setState(
          {
            hotelName: search_text,
            getDestinationId: destination_id,
            getSearchType: search_type,
            isKeyDown: false,
          },
          () => {
            this.onClickVisibilityStatus("hotel", false);
          }
        );
        indexDropdown = -1;
        break;
      case 9: //tab
        this.setState(
          {
            hotelName: search_text,
            getDestinationId: destination_id,
            getSearchType: search_type,
            isKeyDown: false,
          },
          () => {
            this.onClickVisibilityStatus("hotel", false);
          }
        );
        indexDropdown = -1;

        break;
      default:
    }
  };

  focusOutDone = () => {

    this.setState({
      openRoomDetailList: this.state.openRoomDetailList,
    });

  };

  onClickTraveller = () => {
    if (!this.state.openTraveler) {
      this.setState({ openTraveler: true });
    } else {
      this.setState({ openTraveler: false });
    }
  };

  onClickAdvSearch = () => {
    if (!this.state.advSearch) {
      this.setState({ advSearch: true });
    } else {
      this.setState({ advSearch: false });
    }
  };

  onClickNationality = () => {
    if (!this.state.nationallitySearch) {
      this.setState({ nationallitySearch: true });
    } else {
      this.setState({ nationallitySearch: false });
    }
  };

  onTickAdvSearch = () => {
    cf.redirectTo("/hotel/search", urlQuery);
  };

  handleStarCheck = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  handleCheckboxSelection = (event, index) => {
    let updatedSelections = new Array(index + 1).fill(false);
    updatedSelections[index] = event.target.checked;

    this.setState((prev) => ({
      selectedCheckBoxes: {
        ...prev.selectedCheckBoxes,
        [event.target.name]: updatedSelections,
      },
    }));
  };

  adGuestId = (id) => {
    this.setState({ guest_id: id }, () => {
      if (this.state.isError.selectedGuest === true) {
        this.validateErrorMsg();
      }
      this.setState({ guest_id: id });
    });
  };

  rmGuestId = () => {
    this.setState({ guest_id: "" });
  };

  handleOnClick = async (suggestion, index) => {
    this.setState({ selectedDestination: index });
    await this.onClickSetHotelName(suggestion);
    await this.onClickSearchHotel();
    return suggestion;
  };

  handlePaxComp = () => {
    this.setState({
      roomList: [
        ...this.state.roomList,
        {
          id: this.state.roomList.length + 1,
          adults: 1,
          children: 0,
          adultAddCountDisable: false,
          adultMinusCountDisable: true,
          childrenAddCountDisable: false,
          childrenMinusCountDisable: true,
          childDetails: [],
        },
      ],
    });
  };


  clearDate = () => {
    let checkInOut = cf.getDateWithFormat(new Date(), this?.props?.dateFormat) + " - " +
      cf.getDateWithFormat(addDays(new Date(),
        this.props.getDefaultDays ? this.props.getDefaultDays : 2
      ), this?.props?.dateFormat);


    this.setState({
      checkInOutValue: checkInOut,
      checkInValue: new Date(),
      checkOutValue: addDays(new Date(), this.props.getDefaultDays ? this.props.getDefaultDays : 2),
    })
  };

  render() {

    const popularDestination = this.props?.PopularDestination ? true : false;

    return (
      <div
        ref={this.setScrollDown}
        className={`${this.props.isMobile ? this.props.styles?.hotel_mobileContainer : ""
          } ${this.props.styles?.hotel_widget_container}`}
      >
        <div className={this.props.styles?.hotel_search_wid_container}>
          <div className={this.props.styles?.hotel_search_wid_main}>
            <div
              className={`${this.props.styles?.hotel_search_details_container
                } ${this.props.styles?.home_bgcolor
                }`}
            >
              <div className={this.props.styles?.hotel_search_details_main}>
                <div
                  className={this.props.styles?.hotel_search_details_row}
                  ref={this.setDropdownWrapperRef}
                >
                  <div
                    id="hotelList"
                    className={`${this.props.styles?.hotel_search_column} ${this.props.styles?.hotel_search_name
                      } `}
                    tabIndex="1"
                  >
                    {!this.props.isMobile && (

                      <HotelAutoComplete
                        tabIndex={1}
                        isDisable={this.props.isDisable === true}
                        label={""}
                        styles={this.props.styles}
                        value={this.state.hotelName}
                        onKeyDownArrow={(event) => {
                          this.onKeyDownArrow(
                            event,
                            "hotelDataArray",
                            "hotel"
                          );
                        }}
                        placholder={
                          this.props.isOffline
                            ? "Select Country"
                            : "Where are you going?"
                        }
                        onInputFocus={() => {
                          this.onInputFocus("autocomplete");
                        }}
                        onClickHotelInput={() => this.onClickHotelInput()}
                        onClickHotelName={(value) =>
                          this.onClickSetHotelName(value)
                        }
                        onChangeHotelName={(value) =>
                          this.onChangeSetHotelName(value)
                        }
                        isAutoCompleteExpand={(value) =>
                          this.onClickVisibilityStatus("hotel", value)
                        }
                        autoCompleteData={
                          !cf.isValueEmpty(this.props.getAutoSuggestList)
                            ? this.props.getAutoSuggestList
                            : []
                        }
                        expandAutoCompleteBool={
                          !cf.isValueEmpty(this.props.expandHotelNameBoolean)
                            ? this.props.expandHotelNameBoolean
                            : false
                        }
                        leftIcon={
                          <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M12 1.5C7.85953 1.5 4.5 4.52391 4.5 8.25C4.5 14.25 12 22.5 12 22.5C12 22.5 19.5 14.25 19.5 8.25C19.5 4.52391 16.1405 1.5 12 1.5ZM12 12C11.4067 12 10.8266 11.8241 10.3333 11.4944C9.83994 11.1648 9.45542 10.6962 9.22836 10.1481C9.0013 9.59987 8.94189 8.99667 9.05764 8.41473C9.1734 7.83279 9.45912 7.29824 9.87868 6.87868C10.2982 6.45912 10.8328 6.1734 11.4147 6.05764C11.9967 5.94189 12.5999 6.0013 13.1481 6.22836C13.6962 6.45542 14.1648 6.83994 14.4944 7.33329C14.8241 7.82664 15 8.40666 15 9C14.9991 9.79538 14.6828 10.5579 14.1204 11.1204C13.5579 11.6828 12.7954 11.9991 12 12Z" fill="#666666" />
                            </svg>
                          </span>
                        }
                        errorMessage={
                          this.state.isError.hotelName
                            ? ""
                            : "Enter Destination"
                        }
                        isError={this.state.isError.hotelName}
                        isSrp={this.props.isSRP}
                        onStateUpdate={() => this.onClickSetHotelName(this.props?.state)}
                      />
                    )}
                    {this.props.isMobile && (
                      <div
                        className={this.props.styles?.widget_mainBox}
                        onClick={() => {
                          document.querySelector("body").style.overflow =
                            "hidden";
                          this.setState({
                            destination: true,
                          });
                        }}
                      >

                        <div
                          className={this.props.styles?.widgMob_inp}
                          onClick={() => {
                            document.querySelector("body").style.overflow =
                              "hidden";
                            this.setState({
                              destination: true,
                            });
                          }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M10 1.25C6.54961 1.25 3.75 3.76992 3.75 6.875C3.75 11.875 10 18.75 10 18.75C10 18.75 16.25 11.875 16.25 6.875C16.25 3.76992 13.4504 1.25 10 1.25ZM10 10C9.50555 10 9.0222 9.85338 8.61107 9.57867C8.19995 9.30397 7.87952 8.91352 7.6903 8.45671C7.50108 7.99989 7.45157 7.49723 7.54804 7.01227C7.6445 6.52732 7.8826 6.08186 8.23223 5.73223C8.58186 5.3826 9.02732 5.1445 9.51227 5.04804C9.99723 4.95157 10.4999 5.00108 10.9567 5.1903C11.4135 5.37952 11.804 5.69995 12.0787 6.11107C12.3534 6.5222 12.5 7.00555 12.5 7.5C12.4993 8.16282 12.2357 8.79828 11.767 9.26697C11.2983 9.73565 10.6628 9.99928 10 10Z" fill="#666666" />
                          </svg>
                          <input
                            value={this.state.hotelName}
                            type="text"
                            placeholder="City, Property Name Or Location"
                            tabIndex="1"
                          />
                        </div>

                        {this.state.destination == false && (
                          <div className={this.props.styles?.error_message}>
                            <span>
                              {this.state.hotelName == "" &&
                                this.state.isError.hotelName
                                ? "Enter destination"
                                : ""}
                              {this.state.hotelName != "" &&
                                this.props.getAutoSuggestList.length == 0
                                ? "Enter valid destination"
                                : ""}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {!this.props.isMobile && (
                    <div
                      ref={this.setScrollCal}
                      onClick={() => { this.onClickVisibilityStatus("calendar", true) }}
                      className={`${this.props.styles.hotel_search_column} ${this.props.styles.hotel_search_date
                        } `}
                    >

                      <DesktopCalender
                        label=""
                        styles={this.props.styles}
                        value={
                          !cf.isValueEmpty(this.state.checkInOutValue)
                            ? this.state.checkInOutValue
                            : ""
                        }
                        placholder="Check-in/out dates"
                        onChangeDate={(type, value) => {
                          this.onChangeCheckInOutValue(type, value);
                          //  this.setState({ rooms: true });
                        }}
                        onClearDate={(type, value) => {
                          this.clearDate(type, value);
                        }}
                        onInputFocus={() => {
                          this.onInputFocus("calendar");
                        }}
                        iconImage={
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M5.14454 0.692308C5.14454 0.508696 5.07286 0.332605 4.94526 0.202772C4.81767 0.0729394 4.64461 0 4.46417 0C4.28372 0 4.11066 0.0729394 3.98307 0.202772C3.85547 0.332605 3.78379 0.508696 3.78379 0.692308V2.15077C2.47747 2.25692 1.62111 2.51723 0.991533 3.15877C0.361052 3.79938 0.105231 4.67169 0 6H18C17.8948 4.67077 17.6389 3.79938 17.0085 3.15877C16.3789 2.51723 15.5216 2.25692 14.2162 2.14985V0.692308C14.2162 0.508696 14.1445 0.332605 14.0169 0.202772C13.8893 0.0729394 13.7163 0 13.5358 0C13.3554 0 13.1823 0.0729394 13.0547 0.202772C12.9271 0.332605 12.8555 0.508696 12.8555 0.692308V2.08892C12.2522 2.07692 11.5754 2.07692 10.8143 2.07692H7.18567C6.42455 2.07692 5.74781 2.07692 5.14454 2.08892V0.692308Z" fill="#666666" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 9.02041C0 8.26702 1.00583e-08 7.59714 0.0117 7H17.9883C18 7.59714 18 8.26702 18 9.02041V10.8163C18 14.2025 18 15.8961 16.9452 16.9476C15.8904 17.9991 14.1939 18 10.8 18H7.2C3.8061 18 2.1087 18 1.0548 16.9476C0.000899935 15.8952 0 14.2025 0 10.8163V9.02041ZM13.5 10.8163C13.7387 10.8163 13.9676 10.7217 14.1364 10.5533C14.3052 10.3849 14.4 10.1565 14.4 9.91837C14.4 9.68021 14.3052 9.45181 14.1364 9.28341C13.9676 9.11501 13.7387 9.02041 13.5 9.02041C13.2613 9.02041 13.0324 9.11501 12.8636 9.28341C12.6948 9.45181 12.6 9.68021 12.6 9.91837C12.6 10.1565 12.6948 10.3849 12.8636 10.5533C13.0324 10.7217 13.2613 10.8163 13.5 10.8163ZM13.5 14.4082C13.7387 14.4082 13.9676 14.3136 14.1364 14.1452C14.3052 13.9768 14.4 13.7484 14.4 13.5102C14.4 13.2721 14.3052 13.0437 14.1364 12.8753C13.9676 12.7069 13.7387 12.6122 13.5 12.6122C13.2613 12.6122 13.0324 12.7069 12.8636 12.8753C12.6948 13.0437 12.6 13.2721 12.6 13.5102C12.6 13.7484 12.6948 13.9768 12.8636 14.1452C13.0324 14.3136 13.2613 14.4082 13.5 14.4082ZM9.9 9.91837C9.9 10.1565 9.80518 10.3849 9.6364 10.5533C9.46761 10.7217 9.23869 10.8163 9 10.8163C8.7613 10.8163 8.53239 10.7217 8.3636 10.5533C8.19482 10.3849 8.1 10.1565 8.1 9.91837C8.1 9.68021 8.19482 9.45181 8.3636 9.28341C8.53239 9.11501 8.7613 9.02041 9 9.02041C9.23869 9.02041 9.46761 9.11501 9.6364 9.28341C9.80518 9.45181 9.9 9.68021 9.9 9.91837ZM9.9 13.5102C9.9 13.7484 9.80518 13.9768 9.6364 14.1452C9.46761 14.3136 9.23869 14.4082 9 14.4082C8.7613 14.4082 8.53239 14.3136 8.3636 14.1452C8.19482 13.9768 8.1 13.7484 8.1 13.5102C8.1 13.2721 8.19482 13.0437 8.3636 12.8753C8.53239 12.7069 8.7613 12.6122 9 12.6122C9.23869 12.6122 9.46761 12.7069 9.6364 12.8753C9.80518 13.0437 9.9 13.2721 9.9 13.5102ZM4.5 10.8163C4.73869 10.8163 4.96761 10.7217 5.1364 10.5533C5.30518 10.3849 5.4 10.1565 5.4 9.91837C5.4 9.68021 5.30518 9.45181 5.1364 9.28341C4.96761 9.11501 4.73869 9.02041 4.5 9.02041C4.2613 9.02041 4.03239 9.11501 3.8636 9.28341C3.69482 9.45181 3.6 9.68021 3.6 9.91837C3.6 10.1565 3.69482 10.3849 3.8636 10.5533C4.03239 10.7217 4.2613 10.8163 4.5 10.8163ZM4.5 14.4082C4.73869 14.4082 4.96761 14.3136 5.1364 14.1452C5.30518 13.9768 5.4 13.7484 5.4 13.5102C5.4 13.2721 5.30518 13.0437 5.1364 12.8753C4.96761 12.7069 4.73869 12.6122 4.5 12.6122C4.2613 12.6122 4.03239 12.7069 3.8636 12.8753C3.69482 13.0437 3.6 13.2721 3.6 13.5102C3.6 13.7484 3.69482 13.9768 3.8636 14.1452C4.03239 14.3136 4.2613 14.4082 4.5 14.4082Z" fill="#666666" />
                          </svg>
                        }
                        startDate={
                          !cf.isValueEmpty(this.state.checkInValue)
                            ? this.state.checkInValue
                            : ""
                        }
                        endDate={
                          !cf.isValueEmpty(this.state.checkOutValue)
                            ? this.state.checkOutValue
                            : ""
                        }
                        startDateLimit={
                          !cf.isValueEmpty(this.state.dateLimit)
                            ? this.state.dateLimit
                            : ""
                        }
                        dateFormat={this?.props?.dateFormat}
                        changeVisibility={(bool) =>
                          this.onClickVisibilityStatus("calendar", bool)
                        }
                        onEndDateSelected={() => {
                          this.setState({ openRoomDetailList: true });
                        }}
                        isVisible={this.state.expandCheckInOutDateBoolean}
                        type={"double"}
                        doubleSelection={true}
                      />

                    </div>
                  )}
                  {this.props.isMobile && (
                    <div
                      className={`${this.props.styles?.widget_mainBox} ${this.props.styles?.mobile_widget_container_new}`}
                      onClick={() => {
                        this.setState({
                        });
                      }}
                    >
                      <div className={this.props.styles?.widgMob_Wrapflx}>
                        <div className={this.props.styles?.widgMob_sec}>

                          <MobileCalender
                            styles={this.props.styles}
                            value={
                              !commonFunction.isValueEmpty(
                                this.state.checkInOutValue
                              )
                                ? this.state.checkInOutValue
                                : ""
                            }
                            placholder="Select the date"
                            onChangeDate={(type, value) => {
                              this.onChangeCheckInOutValue(type, value);
                            }}
                            iconImage="/images/cyan-calendar.svg"
                            startDate={
                              !commonFunction.isValueEmpty(
                                this.state.checkInValue
                              )
                                ? this.state.checkInValue
                                : ""
                            }
                            endDate={
                              !commonFunction.isValueEmpty(
                                this.state.checkOutValue
                              )
                                ? this.state.checkOutValue
                                : ""
                            }
                            startDateLimit={
                              !commonFunction.isValueEmpty(this.state.dateLimit)
                                ? this.state.dateLimit
                                : ""
                            }
                            dateFormat={"DD-MMM-YYYY"}
                            changeVisibility={(bool) =>
                              this.onClickVisibilityStatus("calendar", bool)
                            }
                            isVisible={this.state.expandCheckInOutDateBoolean}
                            type={"double"}
                            doubleSelection={true}
                            totalMonths={12}
                            serviceType="hotel"
                            isMobile={true}
                            isCheckIn={true}
                            label="Check In"
                            onClearDate={(type, value) => {
                              this.clearDate(type, value);
                            }}
                          />
                        </div>
                        {/* <span
                          className={this.props.styles?.widgMob_arrow}
                          onClick={() => {
                            this.onInputFocus("calendar");
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="11"
                          >
                            <path
                              fill-rule="evenodd"
                              fill="#266AAC"
                              d="m17.373 2.754-7.394 7.457c-.139.14-.3.242-.472.311a1.386 1.386 0 0 1-1.513-.309L.599 2.756a1.417 1.417 0 0 1 0-1.991c.546-.55 1.43-.55 1.975 0L8.985 7.23 15.399.763a1.387 1.387 0 0 1 1.974 0c.546.55.546 1.441 0 1.991z"
                            ></path>
                          </svg>
                        </span> */}
                      </div>
                    </div>
                  )}


                  {this.props.isMobile && (
                    <div
                      className={this.props.styles?.widget_mainBox}
                      onClick={() => {
                        this.setState({
                          rooms: true,
                        });
                        document.querySelector("body").style.overflow =
                          "hidden";
                      }}
                    >
                      <div className={this.props.styles?.widgMob_Wrapflx}>
                        <div className={this.props.styles?.widgMob_sec}>
                          {/* <label className={this.props.styles?.widget_label}>
                            {this.state.selectedRoomDetails.rooms > 1
                              ? "Rooms"
                              : "Room"}{" "}
                            &
                            {this.state.selectedRoomDetails.guest > 1
                              ? " Guests"
                              : " Guest"}
                          </label> */}
                          <div className={this.props.styles?.widgMob_dateInp}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <path d="M10 10C10.8653 10 11.7112 9.74341 12.4306 9.26268C13.1501 8.78195 13.7108 8.09867 14.042 7.29924C14.3731 6.49982 14.4597 5.62015 14.2909 4.77148C14.1221 3.92282 13.7054 3.14326 13.0936 2.53141C12.4817 1.91956 11.7022 1.50288 10.8535 1.33407C10.0049 1.16526 9.12519 1.2519 8.32576 1.58303C7.52633 1.91416 6.84305 2.47492 6.36232 3.19438C5.88159 3.91385 5.625 4.75971 5.625 5.625C5.625 6.78532 6.08594 7.89812 6.90641 8.71859C7.72688 9.53907 8.83968 10 10 10ZM10 11.25C7.28828 11.25 1.875 12.925 1.875 16.25V18.75H18.125V16.25C18.125 12.925 12.7117 11.25 10 11.25Z" fill="#666666" />
                            </svg>
                            <span>
                              {this.state.selectedRoomDetails.rooms > 1
                                ? `${this.state.selectedRoomDetails.rooms} Rooms`
                                : `${this.state.selectedRoomDetails.rooms} Room`}
                              , {this.state.selectedRoomDetails.guest}{" "}
                              {this.state.selectedRoomDetails.guest > 1
                                ? " Guests"
                                : " Guest"}
                            </span>
                          </div>
                        </div>
                        {/* <span className={this.props.styles?.widgMob_arrow}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="11"
                          >
                            <path
                              fill-rule="evenodd"
                              fill="#266AAC"
                              d="m17.373 2.754-7.394 7.457c-.139.14-.3.242-.472.311a1.386 1.386 0 0 1-1.513-.309L.599 2.756a1.417 1.417 0 0 1 0-1.991c.546-.55 1.43-.55 1.975 0L8.985 7.23 15.399.763a1.387 1.387 0 0 1 1.974 0c.546.55.546 1.441 0 1.991z"
                            />
                          </svg>
                        </span> */}
                      </div>
                    </div>
                  )}
                  {this.props.isMobile && (
                    <div className={this.props.styles?.hotel_search_btn} style={{ 'opacity': cf.isValueEmpty(this.state.hotelName) ? '0.5' : 'unset' }}>
                      <Button
                        className={
                          this.state?.btnClicked
                            ? `${this.props.styles?.hotel_search_widget_btn} loading`
                            : this.props.styles?.hotel_search_widget_btn
                        }
                        name={"Search"}
                        isHandleOnClick={this.onClickSearchHotel}
                        disabled={cf.isValueEmpty(this.state.hotelName)}
                      >
                        {"Search"}
                      </Button>
                    </div>
                  )}


                  {!this.props.isMobile &&

                    <PaxComp
                      theme="theme8"
                      styles={this.props.paxCompStyle}
                      onClickVisibilityStatus={this.onClickVisibilityStatus}
                      state={this.state}
                      onInputFocus={this.onInputFocus}
                      removeRoomItem={this.removeRoomItem}
                      minusAccomodationCount={this.minusAccomodationCount}
                      addAccomodationCount={this.addAccomodationCount}
                      isChildrenAge={this.isChildrenAge}
                      setState={this.setState}
                      onClickDoneButton={this.onClickDoneButton}
                      focusOutDone={this.focusOutDone}
                      handlePaxComp={this.handlePaxComp}
                      label={""}
                      adultLabel={""}
                      childLabel={"(Age 11 years & below)"}
                      totalRooms={this.props?.stays_villas ? 6 : 4}
                    />}

                  {!this.props.isMobile && (
                    <div className={this.props.styles?.hotel_search_btn} style={{ 'opacity': cf.isValueEmpty(this.state.hotelName) ? '0.5' : 'unset' }}>
                      <Button
                        className={
                          this.state?.btnClicked
                            ? `${this.props.styles?.hotel_search_widget_btn} loading`
                            : this.props.styles?.hotel_search_widget_btn
                        }
                        name={
                          "Hotels Search"
                        }
                        isHandleOnClick={this.onClickSearchHotel}
                        disabled={cf.isValueEmpty(this.state.hotelName)}
                      >

                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9998 2.65796C9.64436 2.65807 8.30863 2.98232 7.10402 3.60365C5.89941 4.22498 4.86086 5.12538 4.075 6.22971C3.28914 7.33405 2.77878 8.61031 2.58647 9.952C2.39417 11.2937 2.52551 12.6619 2.96954 13.9425C3.41357 15.2232 4.15741 16.379 5.139 17.3137C6.12059 18.2484 7.31147 18.9347 8.61228 19.3156C9.91309 19.6964 11.2861 19.7606 12.6168 19.5029C13.9475 19.2451 15.1972 18.6729 16.2618 17.834L19.9138 21.486C20.1024 21.6681 20.355 21.7689 20.6172 21.7666C20.8794 21.7644 21.1302 21.6592 21.3156 21.4738C21.501 21.2884 21.6062 21.0376 21.6084 20.7754C21.6107 20.5132 21.5099 20.2606 21.3278 20.072L17.6758 16.42C18.6638 15.1666 19.2789 13.6604 19.4509 12.0737C19.6228 10.487 19.3446 8.88398 18.648 7.44805C17.9514 6.01213 16.8646 4.80132 15.5121 3.95419C14.1595 3.10707 12.5957 2.65785 10.9998 2.65796ZM4.49977 11.158C4.49977 9.43405 5.18458 7.78075 6.40357 6.56176C7.62256 5.34278 9.27586 4.65796 10.9998 4.65796C12.7237 4.65796 14.377 5.34278 15.596 6.56176C16.8149 7.78075 17.4998 9.43405 17.4998 11.158C17.4998 12.8819 16.8149 14.5352 15.596 15.7542C14.377 16.9731 12.7237 17.658 10.9998 17.658C9.27586 17.658 7.62256 16.9731 6.40357 15.7542C5.18458 14.5352 4.49977 12.8819 4.49977 11.158Z" fill="white" />
                        </svg>
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {popularDestination && !this.props.isMobile && this.props.getAutoSuggestList && (
              <div className={this.props.styles?.popular_destination}>
                <div className={this.props.styles?.populardest_title}>
                  Popular Destination
                </div>
                <div className={this.props.styles?.destination_container}>
                  {this.props.homeData.map((sugesstion, index) => {
                    let popDestination = sugesstion.search_text.split(",");
                    return (
                      <div
                        key={index}
                        className={
                          index === this.state.selectedDestination
                            ? this.props.styles?.destination_active
                            : this.props.styles?.destination_item
                        }
                        onClick={() => this.handleOnClick(sugesstion, index)}
                      >
                        <div className={this.props.styles?.destination_name}>
                          {popDestination[0]}
                        </div>
                        <div className={this.props.styles?.property_count}>
                          {sugesstion.property_count} Properties
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* For Destination Popup ===> */}

        <MobPopupComponent
          theme="theme5"
          isPopup={this.state.destination}
          modalCss={this.props?.PopupMobCss}
          closePopup={() => {
            this.setState({ destination: false }, () => { });
            // window.scrollTo({ top: 0, behavior: 'smooth' });
            document.querySelector("body").style.overflow = "auto";
          }}
          showBtn={false}
          heading={"What are you doing?"}
        >
          <div>
            <HotelAutoComplete
              isDisable={this.props.isDisable === true}
              label="City, Property Name Or Location"
              styles={this.props.styles}
              value={this.state.hotelName}
              userProfile={this.props.userProfile}
              getrecentSearchList={
                this?.props?.userProfile?.status
                  ? !cf.isValueEmpty(this.props.getRecentSearchList)
                    ? this.props.getRecentSearchList
                    : []
                  : !cf.isValueEmpty(this.state.getrecentSearchListLocal)
                    ? this.state.getrecentSearchListLocal
                    : this.state.getrecentSearchListLocal
              }
              onKeyDownArrow={(event) => {
                this.onKeyDownArrow(event, "hotelDataArray", "hotel");
              }}
              placholder="Enter a city, hotel, airport, address or landmark"
              onInputFocus={() => {
                this.onInputFocus("autocomplete");
              }}
              onClickHotelInput={() => this.onClickHotelInput()}
              onClickHotelName={(value) => {
                this.onClickSetHotelName(value);
                this.setState({ destination: false });
                // window.scrollTo({ top: 0, behavior: "smooth" });
                document.querySelector("body").style.overflow = "auto";
              }}
              onChangeHotelName={(value) => this.onChangeSetHotelName(value)}
              isAutoCompleteExpand={(value) =>
                this.onClickVisibilityStatus("hotel", value)
              }
              autoCompleteData={
                !cf.isValueEmpty(this.props.getAutoSuggestList)
                  ? this.props.getAutoSuggestList
                  : []
              }
              expandAutoCompleteBool={
                !cf.isValueEmpty(this.props.expandHotelNameBoolean)
                  ? this.props.expandHotelNameBoolean
                  : false
              }
              leftIcon={
                <span className={this.props.styles?.label_icon}>
                  <svg
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    width="200px"
                    height="200px"
                    viewBox="0 0 200 200"
                    enableBackground="new 0 0 200 200"
                  >
                    <g>
                      <path
                        fill="currentColor"
                        d="M101,184.511c-0.031,0-0.062,0-0.094-0.001c-1.113-0.026-2.164-0.515-2.902-1.349
c-1.537-1.736-3.586-4.031-6.147-6.885c-2.659-2.961-7.256-8.648-14.055-17.387c-6.738-8.66-12.719-17.192-17.779-25.359
c-5.106-8.243-9.814-17.68-13.991-28.049c-4.284-10.633-6.457-20.179-6.457-28.372c0-16.481,5.985-30.635,17.79-42.068
C69.39,23.395,84.07,17.489,101,17.489s31.546,5.842,43.442,17.365c11.932,11.556,17.982,25.772,17.982,42.255
c0,8.19-2.106,17.607-6.26,27.989c-4.062,10.15-9.045,19.803-14.812,28.688c-5.665,8.729-11.346,17.015-16.885,24.627
c-5.553,7.63-10.354,13.807-14.27,18.359c-0.053,0.062-0.107,0.121-0.164,0.18l-6.167,6.346
C103.114,184.074,102.079,184.511,101,184.511z M101,25.489c-14.988,0-27.441,5.004-38.069,15.298
C52.599,50.795,47.576,62.676,47.576,77.109c0,7.164,1.977,15.704,5.876,25.382c4.007,9.945,8.506,18.972,13.372,26.826
c4.91,7.927,10.729,16.224,17.292,24.66c6.589,8.469,11.196,14.174,13.693,16.955c1.222,1.361,2.329,2.597,3.319,3.706l3.084-3.174
c3.762-4.381,8.399-10.354,13.787-17.758c5.456-7.498,11.056-15.665,16.643-24.275c5.483-8.45,10.226-17.637,14.095-27.305
c3.774-9.433,5.688-17.85,5.688-25.018c0-14.434-5.086-26.376-15.549-36.508C128.378,30.432,115.988,25.489,101,25.489z"
                      />
                    </g>
                    <g>
                      <path
                        fill="currentColor"
                        d="M101,91.748c-7.077,0-12.834-5.757-12.834-12.834S93.923,66.079,101,66.079s12.835,5.757,12.835,12.834
S108.077,91.748,101,91.748z M101,74.079c-2.666,0-4.834,2.169-4.834,4.834s2.169,4.834,4.834,4.834
c2.666,0,4.835-2.169,4.835-4.834S103.666,74.079,101,74.079z"
                      />
                    </g>
                  </svg>
                </span>
              }
              // errorMessage={"Enter Destination"}
              // isError={this.state.isError.hotelName}
              disabled={this.props.isDisable === true}
              isMobile={true}
            />

          </div>
        </MobPopupComponent>

        {/* For Calender Popup ===> */}

        <MobPopupComponent
          theme="theme5"
          isPopup={this.state.calender}
          modalCss={this.props?.PopupMobCss}
          closePopup={() => {
            this.setState({ calender: false });
            document.querySelector("body").style.overflow = "auto";
          }}
          showBtn={false}
          heading={"Select Date"}
        >
          <div>
            <MobileCalender
              // label="Check In & Check Out Date"
              styles={this.props.styles}
              value={
                !commonFunction.isValueEmpty(this.state.checkInOutValue)
                  ? this.state.checkInOutValue
                  : ""
              }
              placholder="Select the date"
              onChangeDate={(type, value) => {
                this.onChangeCheckInOutValue(type, value);
              }}
              iconImage="/images/cyan-calendar.svg"
              startDate={
                !commonFunction.isValueEmpty(this.state.checkInValue)
                  ? this.state.checkInValue
                  : ""
              }
              endDate={
                !commonFunction.isValueEmpty(this.state.checkOutValue)
                  ? this.state.checkOutValue
                  : ""
              }
              startDateLimit={
                !commonFunction.isValueEmpty(this.state.dateLimit)
                  ? this.state.dateLimit
                  : ""
              }
              dateFormat={"DD-MMM-YYYY"}
              changeVisibility={(bool) =>
                this.onClickVisibilityStatus("calendar", bool)
              }
              isVisible={this.state.expandCheckInOutDateBoolean}
              type={"double"}
              doubleSelection={true}
              totalMonths={12}
              serviceType="hotel"
              isMobile={true}
            />
          </div>
        </MobPopupComponent>

        {/* For rooms & guest Popup ===> */}
        <MobPopupComponent
          theme="theme5"
          isPopup={this.state.rooms}
          modalCss={this.props?.PopupMobCss}
          closePopup={() => {
            this.setState({ rooms: false });
            document.querySelector("body").style.overflow = "auto";
          }}
          showBtn={false}
          heading={"Room and Guests"}

        >
          <div className={this.props.styles?.paxMobile_container}>
            <PaxComp
              theme="theme8"
              styles={this.props.paxCompStyle}
              onClickVisibilityStatus={this.onClickVisibilityStatus}
              state={this.state}
              onInputFocus={this.onInputFocus}
              removeRoomItem={this.removeRoomItem}
              minusAccomodationCount={this.minusAccomodationCount}
              addAccomodationCount={this.addAccomodationCount}
              isChildrenAge={this.isChildrenAge}
              setState={this.setState}
              onClickDoneButton={this.onClickDoneButton}
              focusOutDone={this.focusOutDone}
              handlePaxComp={this.handlePaxComp}
              isMobile={true}
              label={""}
              adultLabel={""}
              childLabel={"(Age 11 years & below)"}
              totalRooms={this.props?.stays_villas ? 6 : 4}
            />
          </div>
        </MobPopupComponent>
      </div>
    );
  }
}
